<script setup lang="ts">
import { computed, onMounted, onUnmounted, reactive, ref } from "vue"
import { Subscription } from "rxjs"
import UploadIconBadge from "./UploadIconBadge.vue"
import UploadDialog from "./UploadDialog.vue"
import { useUploads, UploadPhase, type Upload, type UploadState } from "./Uploads"

interface TrackRow {
  id: string
  state: UploadState
  stateSubscription: Subscription
}

const uploads = useUploads()
const rows = ref<TrackRow[]>([])
let sub: Subscription | undefined

onMounted(() => {
  sub = uploads.subscribe((upload: Upload) => {
    const row = reactive<TrackRow>({
      id: "",
      state: { phase: UploadPhase.CREATING },
      stateSubscription: Subscription.EMPTY
    })
    row.stateSubscription = upload.state.subscribe((state) => {
      row.state = state
      if (state.media) row.id = state.media.uuid
    })
    rows.value = [row, ...rows.value]
  })
})

onUnmounted(() => {
  sub?.unsubscribe()
  rows.value.forEach(r => r.stateSubscription.unsubscribe())
})

const activeCount = computed(() => rows.value.filter(r =>
  r.state.phase === UploadPhase.PREPARING
  || r.state.phase === UploadPhase.CREATING
  || r.state.phase === UploadPhase.UPLOADING
).length)

const dirtyCount = ref(0)
const errorCount = computed(() => rows.value.filter(r => r.state.phase === UploadPhase.FAILED).length)
</script>

<template>
  <UploadIconBadge
    :active-count="activeCount"
    :dirty-count="dirtyCount"
    :error-count="errorCount"
  />
  <UploadDialog/>
</template>
